module.exports = __webpack_public_path__ + "img/Assessment2.3d2c2bbb.jpg";